import { doc, getDoc } from 'firebase/firestore';
import type { Firestore } from 'firebase/firestore';

const usernameCache = new Map<string, string>();

function normalizeUsername(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const cleaned = value.trim().replace(/^@+/, '');
  return cleaned.length > 0 ? cleaned : null;
}

export function buildMessageUserParam(username: string | undefined | null, uid: string): string {
  return normalizeUsername(username) || uid;
}

export async function resolveMessageUserParam(
  db: Firestore,
  options: { uid: string; username?: string | null }
): Promise<string> {
  const normalized = normalizeUsername(options.username);
  if (normalized) return normalized;

  const cached = usernameCache.get(options.uid);
  if (cached) return cached;

  try {
    const userSnap = await getDoc(doc(db, 'users', options.uid));
    if (userSnap.exists()) {
      const data = userSnap.data() as { username?: string };
      const resolved = normalizeUsername(data?.username);
      if (resolved) {
        usernameCache.set(options.uid, resolved);
        return resolved;
      }
    }
  } catch {
    // Fallback to uid.
  }

  return options.uid;
}
